import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { QueryKeys } from '../../shared';
import { IDashboardList } from '../models/dashboard-list.model';

async function getDashboards(): Promise<IDashboardList[]> {
    const { data } = await axios.get('/reporting/dashboards');
    return data;
}

export const useDashboards = () => {
    return useQuery<IDashboardList[], AxiosError>({ queryKey: [QueryKeys.Dashboards], queryFn: getDashboards });
};
